import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of } from 'rxjs';
import { map, mergeMap, switchMap } from 'rxjs/operators';
import { userTokenActions } from './user-token-base.state';
import { UserTokenApi } from './user-token.api';
import { UserTokenEntity } from './user-token.entity';

@Injectable()
export class UserTokenBaseEffect {
  #actions$ = inject(Actions);
  #tokenApi = inject(UserTokenApi);
  #userTokenEntity = inject(UserTokenEntity);

  onLoadTokenList$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(userTokenActions.loadTokens),
      switchMap((action) =>
        this.#tokenApi.tokenList$().pipe(
          map((response) => userTokenActions.loadTokensSuccess(response, action)),
          catchError((err) => of(userTokenActions.loadTokensFail(err, action)))
        )
      )
    )
  );

  // Update cache of the User-Token entity
  onLoadTokenListSuccess$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(userTokenActions.loadTokensSuccess),
      mergeMap((action) => [
        this.#userTokenEntity.addToCache(action.data.list),
        this.#userTokenEntity.addIdsToCache(
          action.data.list.map(({ id }) => id),
          { handleGlobally: true }
        )
      ])
    )
  );
}
